<template>
  <p-list v-if="$hasPermission('specifications.read')" />
  <p-not-found v-else />
</template>

<script>
import List from './../components/specifications/List.vue';
import NotFound from './../components/NotFound.vue';
export default {
  components: {
    'p-list': List,
    'p-not-found': NotFound
  }
};
</script>
